import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
  name: 'UpdateBusinessConfiguration',
  components: {
    VueElementLoading,
    Treeselect
  },
  data: function() {
    return {
      shippingID: '',
      isLoading: false
    }
  },
  created: function() {

  },
  async mounted() {
    let validateUser = await this.validateJwtToken();
    var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = userdetail.userid;
    this.localusermailid = userdetail.email;
  },
  methods: {
    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.Update();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    Update() {
      this.input = {
        "ShippingId": this.shippingID.trim(),
        "LastModifiedBy": this.localusermailid
      }
      this.isLoading = true;
      axios({
          method: 'POST',
          url: apiUrl.api_url + 'websupport/update/shipment/businessconfigid',
          data: this.input
        })
        .then(async result => {
          if (result.data.code == 200) {
            this.$alertify.success(result.data.message);
          } else {
            this.$alertify.error(result.data.message);
          }
          this.isLoading = false;
          this.reset();
        })
    },
    reset() {
      this.$validator.reset();
      this.shippingID = '';
      this.isLoading = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/UpdateBusinessConfiguration/UpdateBusinessConfiguration.component.js